export type NewsletterAgreementValues = (typeof newsletterAgreementValues)[number];
export type PhoneContactAgreementValues = (typeof phoneContactAgreementValues)[number];

export const newsletterAgreementValues = ["enabled", "disabled"] as const;
export const phoneContactAgreementValues = ["enabled", "disabled"] as const;
